<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2834.648 2834.648">
  <path d="M1842.522 726.379H992.127c-147.64 0-265.75 118.11-265.75 265.749v850.394c0 147.639 118.11 265.748 265.75 265.748h850.395c147.638 0 265.749-118.109 265.749-265.748V992.127c0-147.638-118.112-265.748-265.75-265.748zm76.772 159.449h29.527v236.22H1712.6v-236.22zm-696.851 389.765c41.338-59.056 118.11-100.395 194.882-100.395s153.544 41.339 194.882 100.395c29.527 41.338 47.244 88.582 47.244 141.732 0 135.826-112.205 242.126-242.126 242.126-129.922 0-242.126-106.299-242.126-242.126 0-53.15 17.716-100.394 47.244-141.732zm750 566.929c0 70.867-59.055 129.922-129.921 129.922H992.127c-70.866 0-129.922-59.055-129.922-129.922v-566.929h206.693c-17.717 41.338-29.527 94.488-29.527 141.732 0 206.693 171.26 377.953 377.953 377.953 206.693 0 377.953-171.26 377.953-377.953 0-47.244-11.812-100.395-29.527-141.732h206.692zm862.205-425.198a1417.324 1417.324 0 01-1417.324 1417.324A1417.324 1417.324 0 010 1417.324 1417.324 1417.324 0 011417.324 0a1417.324 1417.324 0 011417.324 1417.324z"/>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
